import { render, staticRenderFns } from "./postingAdd.vue?vue&type=template&id=788ca955&scoped=true"
import script from "./postingAdd.vue?vue&type=script&lang=js"
export * from "./postingAdd.vue?vue&type=script&lang=js"
import style0 from "./postingAdd.vue?vue&type=style&index=0&id=788ca955&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ca955",
  null
  
)

export default component.exports